
import ListHandler from '@tool/ListHandler'
import { defineComponent } from '@vue/runtime-core'
import Block from '@/components/Block.vue'
import Pagination from '@/components/Pagination.vue'
import { toTop } from '@/utils/tool/Tool'

export default defineComponent({
    setup() {
        const _listCompiler = ListHandler.listCompiler()

        const onPageChange = (startIndex:number, endIndex:number) => {
            toTop()
            _listCompiler.reloadList({startIndex, endIndex})
        }

        return {
            ..._listCompiler,
            onPageChange
        }
    },
    components: { Block, Pagination }
})
